import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { ZSchedulingSettings } from "../../../SchedulingTypes";
import { SchedulingObjType } from "../../SchedulingSettingsStore";

interface PropsTaskTiesSection {
  tabKey: keyof ZSchedulingSettings;
  objType: SchedulingObjType;
  store: FormObjectSectionsStore<SchedulingObjType>;
  title?: string;
}

export const TaskTiesSection: React.FC<PropsTaskTiesSection> = observer(
  ({ tabKey, objType, store, title }) => {
    const isTaskSection =
      tabKey === "taskSettings" || tabKey === "taskTemplateSettings";
    if (!isTaskSection) return null;
    return (
      <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
        store={store}
        objKey={[tabKey, "relationObjectId"]}
        objType={objType}
        title={title}
        attrTitle="Выберите атрибуты:"
        attrs={[
          {
            attrKey: [tabKey, "previousAttributeId"],
            attrLabel: "Предыдущая задача",
            attrType: AttrTypeName.object,
          },
          {
            attrKey: [tabKey, "currentAttributeId"],
            attrLabel: "Текущая задача",
            attrType: AttrTypeName.object,
          },
          {
            attrKey: [tabKey, "relationTypeAttributeId"],
            attrLabel: "Тип привязки",
            attrType: AttrTypeName.dictSingle,
          },
          {
            attrKey: [tabKey, "deltaDaysAttributeId"],
            attrLabel: "Кол-во дней задержки/опережения",
            attrType: AttrTypeName.int,
          },
        ]}
      />
    );
  },
);
